import styles from './index.module.scss';
import QRCode from 'qrcode.react';
import React, { FC, useMemo } from 'react';
import { ownership } from 'src/models/ownership';

export interface QrCodeLinkProps {
  username: string;
  code: string;
  header: string;
  description: string;
}

const QrCodeLink: FC<QrCodeLinkProps> = props => {
  const { username, code, header, description } = props;

  const issuer = useMemo(() => {
    return encodeURIComponent(ownership.qrCodeTitle);
  }, []);

  const qrCodeLink = useMemo(
    () => `otpauth://totp/${window.location.hostname}:${username}?secret=${code}&issuer=${issuer}`,
    [code, issuer, username]
  );

  return (
    <li className={styles.setupStep}>
      <span className={styles.stepTitle}>{header}</span>
      <div className={styles.stepContent}>
        <p>{description}</p>
        <QRCode value={qrCodeLink} className={styles.qrCode} />
      </div>
    </li>
  );
};

export default QrCodeLink;
